import React from 'react';

import { flagStyles } from '../settings';

const SvgMS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3600px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMS;
